// extracted by mini-css-extract-plugin
module.exports = {"Container":"Image_Container__2q9el","Loading":"Image_Loading__2V9x2","Update":"Image_Update__34ZPr"};